import api from "../api";
import { subscribeToChannel, unsubscribeToChannel } from "../services/pusher";

const state = {
  selectedDate: null,
  tasks: [],
};

const getters = {
  tasks(state) {
    return state.tasks;
  },
};

const mutations = {
  setup(state, data) {
    state.tasks = data.tasks
  },
  updateSelectedDate(state, date) {
    state.selectedDate = date
  },
  teardown(state) {
    state.selectedDate = null
    state.tasks = []
  },
};

const actions = {
  setup({commit, state, rootState, getters}, selectedDate) {
    subscribeToChannel("dashboardActive", rootState.activeUser.id)

    return api.clientStore.initDashboardActive(rootState.activeUser.id, selectedDate).then(response => {
      commit("updateSelectedDate", selectedDate)
      commit('setup', response.data);
    })
  },
  tearDown({commit, state, rootState, getters}) {
    unsubscribeToChannel("dashboardActive", rootState.activeUser.id)
    commit('teardown')
  },
};

const DashboardActiveStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default DashboardActiveStore;
